export default __webpack_public_path__ + "static/media/fbx_logo.4deda922.png";